import React from 'react';
import {
  Stack,
  Icon,
  Card,
  Text,
} from '@piwikpro/ui-components';

export interface IFailMessageProps {
  t: (key: string) => string
}

export const FailMessage = ({ t }: IFailMessageProps) => (
  <Card>
    <Card.Section>
      <Stack
        vertical
        horizontalAlignment="middle"
        verticalAlignment="center"
        spacing="extraWide"
      >
        <Stack.Item fill />
        <Stack.Item>
          <Stack
            vertical
            horizontalAlignment="middle"
          >
            <Stack.Item>
              <Icon
                color="red"
                name="exclamation-mark-circle"
                size="medium"
              />
            </Stack.Item>
            <Stack.Item>
              <Text color="Red" dataId="TextStyle">
                {t('general.cardWithControls.failMessage.description')}
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item fill />
      </Stack>
    </Card.Section>
  </Card>
);

export default FailMessage;
